import { render, staticRenderFns } from "./mobile_index.vue?vue&type=template&id=3001679b&scoped=true"
import script from "./mobile_index.vue?vue&type=script&lang=js"
export * from "./mobile_index.vue?vue&type=script&lang=js"
import style0 from "./mobile_index.vue?vue&type=style&index=0&id=3001679b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3001679b",
  null
  
)

export default component.exports